import { atQuery } from '../../scripts/components/mediaQueries';
import './template-product.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateProduct = (context) => {
  const templateProductSection = context.closest('.shopify-section');
  if (!templateProductSection) return;

  const productsGalleries = templateProductSection.querySelectorAll('.product-gallery--carousel');
  productsGalleries.forEach(productsGallery => {
    new Swiper(productsGallery.querySelector('.product-gallery__container'), {
      loop: false,
      direction: 'horizontal',
      pagination: {
        el: productsGallery.querySelector('.product-gallery__pagination'),
        type: 'progressbar',
        clickable: true
      },
      navigation: {
        prevEl: productsGallery.querySelector('.product-gallery__arrow--left'),
        nextEl: productsGallery.querySelector('.product-gallery__arrow--right')
      },
      breakpoints: {
        1025: {
          allowSlidePrev: true,
          allowSlideNext: true
        }
      }
    });

  });

  const productMeta = templateProductSection.querySelector('.product__meta');
  const productForm = templateProductSection.querySelector('.product__form');
  const productFormActions = templateProductSection.querySelector('.product__form__actions');
  const productMedia = templateProductSection.querySelector('.product__medias-wrapper');
  const productWishlist = templateProductSection.querySelector('.product__meta__wishlist');
  const filterContentTrigger = document.querySelector('.product__form__option summary');
  const filterContentSizeSelected = filterContentTrigger.querySelector('label span');

  atQuery('max', 'lg', () => {
    productMedia.append(productWishlist);
  });

  atQuery('min', 'lg', () => {
    productFormActions.append(productWishlist);
  });


  productForm.querySelectorAll('.product__form__option__toggle').forEach(toggle => {
    const fieldset = toggle.closest('fieldset');
    if (!fieldset) return;
    toggle.addEventListener('click', (e) => {
      if (toggle.getAttribute('checked')) return;
      const checkedLabels = fieldset.querySelectorAll('label[checked]');
      checkedLabels.forEach(label => { label.removeAttribute('checked') });
      toggle.setAttribute('checked', '');
      if(!!filterContentTrigger != false && !!filterContentSizeSelected != false) {
        const currentLabel = $.trim($(e.target).text());
        filterContentSizeSelected.innerText = currentLabel;
        setTimeout(() => {
          filterContentTrigger.click();
        }, 10);
      }
    });
  });

  const generalTag = productMeta.querySelector('.product__meta__tag:not(.product__meta__tag--sale):not(.product__meta__tag--sold-out)');
  $(context).on('variantChange', e => {
    if (!e || !e.variant) return;

    if (generalTag) {
      generalTag.classList.add('active');
    }

    const selectedOption = productForm.querySelector(`select[name="id"] option[value="${e.variant.id}"][data-stock]`);
    if (!selectedOption) return;
  });

}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
    window.dAgency.initTemplateProduct(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
      window.dAgency.initTemplateProduct(el);
    });
  });
}
